module.exports = __webpack_public_path__ + "img/Ellipse 436.fa30ad8b.png";